module.exports = __webpack_public_path__ + "static/media/foto 1_daniel saboya.614dbcac.jpg";